import { registerFormValidators } from "@neu/libui";

import {
	validateDuplicateMemberPlan,
	validatePatientDates,
	validateRequiredInsurance,
} from "./patient";
import { WarnPlanOnHold } from "./plan_invoice";
import {
	normalizePlanInvoiceRows,
	populatePlanMedicalCarrierFields,
	populatePlanPBMFields,
} from "./plan_invoice";

export function registerDomainFormValidators(): void {
	registerFormValidators([
		{ entityPattern: "patient", validator: validatePatientDates },
		{ entityPattern: "patient", validator: validateRequiredInsurance },
		{ entityPattern: "patient", validator: validateDuplicateMemberPlan },
		{ entityPattern: "plan_invoice", validator: WarnPlanOnHold },
		{ entityPattern: "plan_invoice", validator: normalizePlanInvoiceRows },
		{
			entityPattern: "plan_medical_carrier",
			validator: populatePlanMedicalCarrierFields,
		},
		{ entityPattern: "plan_pbm", validator: populatePlanPBMFields },
	]);
}
